module.exports = __webpack_public_path__ + "img/Widget.c4cd4691.png";